import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "./components/Layout";
import CartPage from "./pages/CartPage";
import CreatePage from "./pages/CreatePage";
import ExplorerPage from "./pages/ExplorerPage";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/ProfilePage";
import ReelPage from "./pages/ReelPage";
import RegisterPage from "./pages/RegisterPage";
import ShopPage from "./pages/ShopPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      // <RequireAuth>
      <Layout />
      // </RequireAuth>
    ),
    errorElement: <>Page not found!</>,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/explorer",
        element: <ExplorerPage />,
      },
      {
        path: "/reel",
        element: <ReelPage />,
      },
      {
        path: "/shop",
        element: <ShopPage />,
      },
      {
        path: "/profile",
        element: <ProfilePage />,
      },
      {
        path: "/register",
        element: <RegisterPage />,
      },
      {
        path: "/create",
        element: <CreatePage />,
      },
      {
        path: "/cart",
        element: <CartPage />,
      },
    ],
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
